// constants.js
export const ROLES = {
  ADMIN: "ADMIN",
  SITE_BUSINESS_HEAD: "SITE_BUSINESS_HEAD",
  PLANT_HEAD: "PLANT_HEAD",
  MANAGER: "MANAGER",
  SUPERVISOR: "SUPERVISOR",
  TECHNICIAN: "TECHNICIAN",
  PLANNING_ENGINEER: "PLANNING_ENGINEER",
  PLANNING_MANAGER: "PLANNING_MANAGER",
  IE_ENGINEER: "IE_ENGINEER",
  IE_MANAGER: "IE_MANAGER",
};

// Role-based default route for now
export const DEFAULT_ROUTES = {
  [ROLES.ADMIN]: "/admin/user",
  [ROLES.SITE_BUSINESS_HEAD]: "/admin/dashboard",
  [ROLES.PLANT_HEAD]: "/admin/dashboard",
  [ROLES.MANAGER]: "/admin/dashboard",
  [ROLES.SUPERVISOR]: "/admin/dashboard",
  [ROLES.TECHNICIAN]: "/technician/dashboard",
  [ROLES.PLANNING_ENGINEER]: "/admin/dashboard",
  [ROLES.PLANNING_MANAGER]: "/admin/dashboard",
  [ROLES.IE_ENGINEER]: "/admin/dashboard",
  [ROLES.IE_MANAGER]: "/admin/dashboard",
};

export const STATUS = [
  { label: "ACTIVE", value: "Active" },
  { label: "INACTIVE", value: "Inactive" },
];

//Regex
export const REGEX = {

  //email regex
  EMAIL_REGEX:
    /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/,
};

export const activityTypeOptions = [
  { label: "Direct", value: "DIRECT" },
  { label: "Indirect", value: "INDIRECT" },
  { label: "Idle", value: "IDLE" },
  { label: "Waiting", value: "WAITING" },
];